// src/main.js — входната точка на frontend-а (Фаза 3.3: app.js е мъртъв,
// всичко е ES модули, билднати от Vite до /dist/main.js).
//
// Правило на фазата: чист vanilla JS, никакви библиотеки/framework-и.

import './shell/registry.js'; // обвивката на fetch за отметката „Данни"
import './shell/theme.js';    // прилага темата преди първия рендер

import { toast } from './shared/toast.js';
import { setUnauthorizedHandler } from './shared/api.js';
import { state } from './shared/state.js';
import { renderShell, renderView, needsCompany, initRouting } from './shell/shell.js';
import { renderAuth, boot } from './shell/auth.js';

import * as help from './help/index.js';
import * as howto from './howto/index.js';
import * as tasks from './tasks/index.js';
import * as calculators from './calculators/index.js';
import * as emaillog from './emaillog/index.js';
import * as checklist from './checklist/index.js';
import * as users from './users/index.js';
import * as companies from './companies/index.js';
import * as dashboard from './dashboard/index.js';
import * as protocols from './protocols/index.js';
import * as contacts from './contacts/index.js';
import * as dossiers from './dossiers/index.js';
import * as proformas from './proformas/index.js';
import * as invoices from './invoices/index.js';
import * as articles from './invoices/articles.js';
import * as calendar from './calendar/index.js';
import * as vehicles from './vehicles/index.js';
import * as audit from './audit/index.js';
import * as backup from './backup/index.js';
import * as fees from './fees/index.js';
import * as warehouseView from './warehouse/index.js';
import * as purchases from './purchases/index.js';
import * as zaplati from './zaplati/index.js';
import * as filesView from './files/index.js';
import * as phoneupload from './phoneupload/index.js';

// Регистърът на екраните (диспечерът в shell.js чете оттук).
window.CRM_MODULES = {
  help: { view: help.view },
  howto: { view: howto.view },
  tasks: { view: tasks.view },
  calculators: { view: calculators.view },
  emaillog: { view: emaillog.view },
  checklist: { view: checklist.view },
  users: { view: users.view },
  companies: { view: companies.view },
  dashboard: { view: dashboard.view },
  protocols: { view: protocols.view },
  contacts: { view: contacts.view },
  dossiers: { view: dossiers.view },
  proformas: { view: proformas.view },
  invoices: { view: invoices.view },
  articles: { view: articles.view },
  calendar: { view: calendar.view },
  vehicles: { view: vehicles.view },
  audit: { view: audit.view },
  backup: { view: backup.view },
  fees: { view: fees.view },
  warehouse: { view: warehouseView.view, helpAnchor: warehouseView.helpAnchor },
  purchases: { view: purchases.view },
  zaplati: { view: zaplati.view },
  files: { view: filesView.view },
  phoneupload: { view: phoneupload.view },
};

// Вътрешният API между екранните модули и рамката (бившият мост от app.js —
// от Фаза 3.3 собственост на модулите; държи се за да не се пипат 13 екрана).
window.CRM = { state: state(), needsCompany, renderShell, renderView, renderAuth };

// Контракти с класическите скриптове (registry-autofill.js вика window.toast).
window.toast = toast;

// 401 от api() → изчистване и екран за вход (същото поведение като винаги).
setUnauthorizedHandler(() => {
  if (state().user) { state().user = null; renderAuth(); return true; }
  return false;
});

// Разделът от адреса се чете ПРЕДИ boot: F5 на „#/invoices" пуска фактурите,
// не Таблото (Фаза А.7).
initRouting();
boot();
